module.exports = __webpack_public_path__ + "static/media/james2.25ab44c0.jpg";